import { type FC, useMemo } from 'react';
import { Layer, Source } from 'react-map-gl';
import {
  vesselIconLayer,
  vesselPointLayer,
  vesselShapeLayer,
  vesselShapeLayer3D,
  vesselTextLayer,
} from '../constants/layers-config';
import { getVesselsFeatures } from '../utils/layer-utils';
import { type MmsiKey, type VesselPosition, type VesselViewModel } from '../../../types';
import { layerSources } from '../constants/constants';
import { useMapContext } from '../../GlobalContextProvider/GlobalContextProvider';

interface Props {
  zoomLevel: number;
  vesselPositions: VesselPosition[];
  vesselData: Record<MmsiKey, VesselViewModel>;
  targetVesselMmsi: MmsiKey;
}

const VesselsLayer: FC<Props> = ({ zoomLevel, vesselPositions, vesselData, targetVesselMmsi }) => {
  const { settings } = useMapContext();
  const data = useMemo(() => {
    const positions = targetVesselMmsi ? vesselPositions.filter(p => p.mmsi !== targetVesselMmsi) : vesselPositions;
    return {
      type: 'FeatureCollection',
      features: getVesselsFeatures(positions, vesselData, settings, zoomLevel),
    };
  }, [vesselPositions, zoomLevel, vesselData, targetVesselMmsi]);

  return (
    <Source id={layerSources.vessels} type="geojson" data={data}>
      <Layer {...vesselIconLayer} />
      <Layer {...vesselShapeLayer} />
      <Layer {...vesselShapeLayer3D} />
      <Layer {...vesselPointLayer} />
      {settings?.showVesselNames ? <Layer {...vesselTextLayer} /> : null}
    </Source>
  );
};

export default VesselsLayer;
